var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEnvelope = function SvgEnvelope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 124 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M123.548.732v87.669H.812V.732h122.736ZM6.658 6.577v75.979h111.046V6.577H6.657Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.704 6.577 62.8 38.687 6.657 6.576v8.882L62.8 47.62l54.904-32.16V6.577Z"
  })));
};
export default SvgEnvelope;